import {
  NearbyShippingOptionModel,
  NearbyShippingPointModel,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

type PointModel = {
  option: NearbyShippingOptionModel
  point: NearbyShippingPointModel
}

export const getMatchingCarrierPoints = (
  shippingOptions: Array<NearbyShippingOptionModel>,
  shippingPoints: Array<NearbyShippingPointModel>,
): Array<PointModel> => {
  return shippingOptions.reduce<Array<PointModel>>((matchingPairs, option) => {
    const matchingPoints = shippingPoints.filter(
      point => point.point.carrierCode === option.lastMileCarrier.code,
    )

    matchingPoints.forEach(matchingPoint => {
      matchingPairs.push({
        option,
        point: matchingPoint,
      })
    })

    return matchingPairs
  }, [])
}
